import React from 'react';
import {useAllCallLogs, useCallLogsByDate} from "../../../../sdk/queries";
import {SimpleCallLogs} from "../../../../sdk/queries/types";
import moment from "moment";


export interface I800CallLogsLoading {
    allCallLogs: boolean;
}

export type NCallsByState = {
    [state: string]: number;
}

export type DataAction = "update" | "delete" | "create";

export interface ITSMMonitoringContext {
    callLogs: SimpleCallLogs[];
    nCallsByState: NCallsByState;
    loading: I800CallLogsLoading;
    selectedYear: string;
    setSelectedYear: React.Dispatch<React.SetStateAction<string>>
    selectedMonth: string;
    setSelectedMonth: React.Dispatch<React.SetStateAction<string>>
    notifyCallLogsChange(id: number, change: DataAction): void;
}

// @ts-ignore
export const TSMMonitoringContext = React.createContext<ITSMMonitoringContext>();


export const TSMMonitoringProvider: React.FC = ({
    children,
}) => {

    const [selectedYear,setSelectedYear] = React.useState(() => {
        var path = window.location.pathname;
        return path.substring(path.lastIndexOf('/')+1,path.lastIndexOf('-'));
    });

    const [selectedMonth,setSelectedMonth] = React.useState(() => {
	var path = window.location.pathname;
        return path.substring(path.lastIndexOf('-')+1);
    });

    const {data: _callLogs, loading: loadingAllCallLogs, refetch: refetchAllCallLogs} = useCallLogsByDate({
        variables: {
            date: selectedYear,
        },
        cachePolicy: "no-cache",
    });


    const [callLogs, setCallLogs] = React.useState<SimpleCallLogs[]>([]);

    const [nCallsByState, setNCallsByState] = React.useState<NCallsByState>({});


    React.useLayoutEffect(() => {
        if(!loadingAllCallLogs) {
            setCallLogs(_callLogs?.data?.map(x => x) ?? []);
        }
    }, [_callLogs, loadingAllCallLogs]);

    React.useEffect(() => {
        const s: NCallsByState = {};
        for(const cl of callLogs) {
            s[cl.callerState] = (s[cl.callerState] || 0) + 1;
        }
        setNCallsByState(s);
    }, [callLogs]);


    return (
        <TSMMonitoringContext.Provider value={{
            callLogs,
            nCallsByState,
            selectedYear,
            setSelectedYear,
	    selectedMonth,
	    setSelectedMonth,
            loading: {
                allCallLogs: loadingAllCallLogs,
            },
            notifyCallLogsChange(id, isEdit) {
                refetchAllCallLogs(true);
            },
        }}>
            {children}
        </TSMMonitoringContext.Provider>
    )
}
